(function () {
  const GIFT_VARIANT_ID = 53025180516689;
  const THRESHOLD = 70000; // €200,00 in centen
  const GIFT_PROPERTY_KEY = '_free_gift';

  let isProcessing = false;

  function getSections() {
    const drawer = document.querySelector('cart-drawer');
    return drawer?.getSectionsToRender().map(s => s.section) || [];
  }

  async function getCart() {
    return fetch('/cart.js').then(r => r.json());
  }

  async function addGift() {
    const sections = getSections();
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { [GIFT_PROPERTY_KEY]: 'true' } }],
        sections: sections,
        sections_url: window.location.pathname
      })
    });
    const data = await res.json();
    if (data.sections) {
      document.querySelector('cart-drawer')?.renderContents(data, false);
    }
  }

  async function removeGift(line) {
    const sections = getSections();
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: 0,
        sections: sections,
        sections_url: window.location.pathname
      })
    });
    const data = await res.json();
    if (data.sections) {
      document.querySelector('cart-drawer')?.renderContents(data, false);
    }
  }

  async function checkAndHandleGift() {
    if (isProcessing) return;
    isProcessing = true;
    try {
      const cart = await getCart();
      const giftItem = cart.items.find(
        item => item.variant_id === GIFT_VARIANT_ID &&
        item.properties?.[GIFT_PROPERTY_KEY] === 'true'
      );
      const giftInCart = !!giftItem;
      const giftLine = giftItem ? cart.items.indexOf(giftItem) + 1 : null;
      const aboveThreshold = cart.total_price >= THRESHOLD;

      if (aboveThreshold && !giftInCart) {
        await addGift();
      } else if (!aboveThreshold && giftInCart) {
        await removeGift(giftLine);
      }
    } finally {
      isProcessing = false;
    }
  }

  function patchUpdateQuantity() {
    const cartItems = document.querySelector('cart-drawer-items');
    if (!cartItems || cartItems._giftPatched) return;
    cartItems._giftPatched = true;
    const original = cartItems.updateQuantity.bind(cartItems);
    cartItems.updateQuantity = function(line, quantity, name) {
      original(line, quantity, name);
      setTimeout(checkAndHandleGift, 500);
    };
  }

  const drawer = document.querySelector('cart-drawer');
  const originalRenderContents = drawer.renderContents.bind(drawer);
  drawer.renderContents = function(response, open) {
    originalRenderContents(response, open);
    setTimeout(() => {
      patchUpdateQuantity();
      checkAndHandleGift();
    }, 300);
  };

  patchUpdateQuantity();
  checkAndHandleGift();
})();